import api from 'src/Utils/api';
export var createTicket = function (params) {
    return api.post('/tickets', { ticket: params });
};
